import { isNil } from 'lodash';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const navigateTo = createAsyncThunk('threadUi/navigateTo', async ({ history }: { history }, { getState }) => {
  const { anon, modifierIndex, moduleIndex, anonModifierIndex, revisionId } = (getState() as unknown as { threadUi })
    .threadUi;

  let search = '';

  if (!isNil(moduleIndex)) {
    search += `&moduleIndex=${moduleIndex}`;
  }

  if (!isNil(modifierIndex)) {
    search += `&modifierIndex=${modifierIndex}`;
  }

  if (anon && !isNil(anonModifierIndex)) {
    search += `&anonModifierIndex=${anonModifierIndex}`;
  }

  if (anon) {
    search += '&anon=true';
  }

  if (revisionId) {
    search += `&revisionId=${revisionId}`;
  }

  history.replace({
    ...history.location,
    search,
  });
});
